<template>
	<div class="container">
		<div class='team-slideout' >
			<triangle-image
				:style="background"
				:title="supplier ? supplier.title : ``"
				:subtitle="supplier ? supplier.description_short : ``" 
			/>
		</div>

		<div class="content" v-if="supplier">
			<div class="supplier-content">
				<h2>{{ supplier.title_1 }}</h2>
				<p v-html="urlify(supplier.description_1)" />

				<h2>{{ supplier.title_2 }}</h2>
				<p v-html="urlify(supplier.description_2)" />

				<h2>{{ supplier.title_3 }}</h2>
				<p v-html="urlify(supplier.description_3)" />
			</div>

			<br>

			<h2 v-if="sliderSrc && sliderSrc.length > 0"
				v-html="type === 'recipes' 
					? 'Ecco alcune ricette realizzate con i loro prodotti'
					: 'Ecco alcuni prodotti che puoi trovare sullo shop'"
			/>

			<slick v-if="sliderSrc && sliderSrc.length > 0">
				<template slot="slides">
					<div class='recipe' v-for="(item, index) in sliderSrc" :key="index">
						<a :href="'/ricetta/' + item.url" v-if="type === 'recipes'">
							<img :src="item.images.small ? item.images.small : item.images.big" :alt='item.title'>
						</a>
						<a :href="'/checkout/prodotto/' + item.id"  v-if="type === 'extras'">
							<img :src="item.images.small ? item.images.small : item.images.big" :alt='item.title'>
						</a>		
						<div class="recipe-name">{{ item.title }}</div>
					</div>
				</template>
			</slick>
		</div>

		<div class="grey">

			<div class="content">

				<h2>Scopri altre storie su gusto e artigianalità</h2>

				<p class="center">Clicca qui sotto per scorrere l’elenco dei nostri produttori di alta qualità.</p>
			
				<router-link :to="{ name: 'suppliers' }" class="flex flex-center">
					<CTA
						:content="`Torna ai produttori`"
						isArrow
					/>
				</router-link>

			</div>

		</div>

	</div>

</template>

<script>

import TriangleImage from '../../components/TriangleImage'
import { SupplierApi } from '../../api/SupplierApi'

import Slick from '../Slick'
import { goSlick } from '../../assets/js/slick'

import { AllRecipesApi } from '../../api/AllRecipesApi'

import { ExtraApi } from '../../api/ExtraApi'
export default {
	components: {
		TriangleImage,
		Slick
	},

	data () {
		return {
			supplier: null,
			sliderSrc: null,
			type: null
		}
	},

	computed: {
		background () {
			if (!this.supplier) return
			return {
				backgroundImage: 'url(' + (this.supplier.images.big ? this.supplier.images.big : '') + ')'
			}
		}
	},


	methods: {

		urlify (text) {
		    var urlRegex = /(https?:\/\/[^\s]+)/g;
		    return text.replace(urlRegex, function(url) {
		        return '<a href="' + url + '" class="link-detail" target="_blank">' + url + '</a>';
		    })
		},

		loadExtras (supplerTitle) {
			var em = new ExtraApi()
			return em.all({
				params: {
					show: 6,
					page: 1,
					sort_direction: 'asc',
					query: `supplier.name eq '${supplerTitle}'`
				}
			})

			.then(response => {
				this.sliderSrc = response.body.data.resources
				this.type = 'extras'
			})
		},

		loadRecipes (supplerTitle) {
			var recipesApi = new AllRecipesApi()
			return recipesApi.get({
				params: {
	                show: 6,
	                page: 1,
	                sort_direction: 'desc',
	                query: `product.productables.product.supplier.name eq '${supplerTitle}'`
	            }
            })

            .then(response => {
                this.sliderSrc = response.body.data.resources
                this.type = 'recipes'
            })
		},

		loadSrc () {
			if (!this.supplier) return

			var supplerTitle = this.supplier.title
			if (supplerTitle === 'Tutte le spezie del mondo') supplerTitle = 'Anandamina srl'
			if (supplerTitle.toLowerCase().includes('benvolio')) supplerTitle = 'Benvolio'
			if (supplerTitle.toLowerCase().includes('filette')) supplerTitle = 'Filette'

			return this.loadRecipes(supplerTitle)

			.then(response => {
				if (this.sliderSrc.length > 0 && supplerTitle !== 'Martini') return Promise.resolve
				return this.loadExtras(supplerTitle)
			})
		},

		loadSupplier () {
			if (this.$route.params.supplier) {
				this.supplier = this.$route.params.supplier
				return Promise.resolve()
			} else {
				var sm = new SupplierApi()
				return sm.all({})

				.then(response => {
					this.supplier = response.body.data.resources.find(record => record.url === this.$route.params.id)
				})
			}
		}
		
	},

	mounted () {
		
		return this.loadSupplier()

		.then(reposnse => {	
			return this.loadSrc()
		})
		
		.then(reposnse => {
			goSlick()
		})
	}
}

</script>

<style scoped>
h2 {
	text-align: center;
}
.triangle-image {
	background-position: center 40%;
}

.content {
	max-width: 800px;
}

.supplier-content {
	white-space: pre-line;
}

.grey {
	background-color: #EDEDED;
}

p + h2 {
	margin-top: 30px;
}

@media(max-width: 640px){
	.content {
		padding: 45px 15px;
	}
}
</style>
